import type { SyncResponse, ZenSession } from "@qz/shared";

const API_BASE = import.meta.env.VITE_API_URL ?? "/api";

interface LoginResponse {
  session: ZenSession;
}

class ApiError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, init);
  if (!res.ok) {
    let msg = `Erro ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) msg = body.error;
    } catch {
      /* keep default */
    }
    throw new ApiError(res.status, msg);
  }
  return res.json() as Promise<T>;
}

export async function apiLogin(
  username: string,
  password: string,
  tenant: string,
): Promise<ZenSession> {
  const data = await request<LoginResponse>("/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password, tenant }),
  });
  return data.session;
}

export async function apiSync(session: ZenSession): Promise<SyncResponse> {
  return request<SyncResponse>("/sync", {
    method: "POST",
    headers: { "X-QZ-Session": btoa(JSON.stringify(session)) },
  });
}

/**
 * Baixa o PDF original de um documento. O Worker faz proxy stateless dos bytes;
 * nada é gravado no servidor. Retorna o Blob para o browser salvar localmente.
 */
export async function apiDownload(
  session: ZenSession,
  doc: { download_id: string; doc_id: string; download_filename: string },
): Promise<Blob> {
  const res = await fetch(`${API_BASE}/download`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-QZ-Session": btoa(JSON.stringify(session)),
    },
    body: JSON.stringify(doc),
  });
  if (!res.ok) {
    let msg = `Erro ${res.status}`;
    try {
      const body = (await res.json()) as { error?: string };
      if (body.error) msg = body.error;
    } catch {
      /* keep default */
    }
    throw new ApiError(res.status, msg);
  }
  return res.blob();
}

export { ApiError };
